export default __webpack_public_path__ + "static/media/facebook.inline.59283628.svg";